const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);

function getSafeUrl(value) {
  try {
    const url = new URL(String(value || ''), document.baseURI);
    return ALLOWED_PROTOCOLS.has(url.protocol) ? url : null;
  } catch (_error) {
    return null;
  }
}

function scrollToTarget(selector) {
  if (!selector.startsWith('#')) return;

  try {
    const target = document.querySelector(selector);
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.history.replaceState(null, '', selector);
  } catch (_error) {
    return;
  }
}

function downloadFile(url) {
  const downloadUrl = new URL(url.href);
  downloadUrl.searchParams.set('download', Date.now().toString(36));

  const link = document.createElement('a');
  link.href = downloadUrl.href;
  link.download = downloadUrl.pathname.split('/').pop() || '';
  link.hidden = true;
  document.body.append(link);
  link.click();
  link.remove();
}

function runAction(button) {
  const destination = String(button.dataset.actionUrl || '').trim();
  const mode = button.dataset.actionMode || 'navigate';

  if (mode === 'scroll') {
    scrollToTarget(destination);
    return;
  }

  const url = getSafeUrl(destination);
  if (!url) return;

  if (mode === 'download') {
    downloadFile(url);
    return;
  }

  if (mode === 'new-tab') {
    const openedWindow = window.open(url.href, '_blank', 'noopener,noreferrer');
    if (openedWindow) openedWindow.opener = null;
    return;
  }

  window.location.assign(url.href);
}

export default function initActionButtons() {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-action-url]');
    if (!button || button.disabled) return;
    runAction(button);
  });
}
